import { Component, OnInit, Output, EventEmitter, ComponentRef } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Subject, Observable } from 'rxjs';
import { AddMembersComponent } from 'app/members/add-members/add-members.component';
import { SignupComponent } from 'app/shared/signup/signup.component';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.css'],
  providers: [SignupComponent]
})
export class CameraComponent implements OnInit {
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();
  public croppedImage: string = '';

  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];
  index: number = 0;

  // latest snapshot
  public webcamImage: WebcamImage = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  constructor(private LanguageService: LanguageService, private memeberComponent: AddMembersComponent, private signupComponent: SignupComponent) { }

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("CameraComponent", label);
  }

  ngOnInit(): void {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
  }

  triggerSnapshot(): void {
    this.index = 1;
    this.trigger.next();
  }

  toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
    if (this.memeberComponent) {
      this.memeberComponent.dialogVisibility = false;
      this.memeberComponent.dialogVisible = false;
    }
    if (this.signupComponent) {
      this.signupComponent.dialogVisibility = false;
    }
  }

  handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  handleImage(webcamImage: WebcamImage): void {
    this.pictureTaken.emit(webcamImage);
    this.webcamImage = webcamImage;
  }

  cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  imageCropped(event) {
    this.croppedImage = event.base64;
  }
  Upload() {
    if (this.memeberComponent) {
      if (this.memeberComponent.member) {
        this.memeberComponent.member.profile = this.croppedImage;
        this.memeberComponent.dialogVisibility = false;
        this.memeberComponent.dialogVisible = false;
      }
    }
    if (this.signupComponent) {
      if (this.signupComponent.member) {
        this.signupComponent.member.profile = this.croppedImage;
        this.signupComponent.dialogVisibility = false;
      }
    }
    this.index = 0;
  }

  handleChange(index) {
    this.index += index;
  }
}
